import CommonTitle from '../home/components/CommonTitle.vue';
export default {
  components: {
    CommonTitle
  }
};